import React from "react";
import { ReactComponent as GreenStarIcon } from "../../img/butter_svgs/GreenStar.svg";
import { ReactComponent as TickIcon } from "../../img/butter_svgs/Tick.svg";
import styled from "@emotion/styled";

export interface SuccessTickProps {}

export const SuccessTick: React.FC<SuccessTickProps> = () => {
  return (
    <SuccessTickContainer>
      <GreenStarIcon />
      <StyledTick />
    </SuccessTickContainer>
  );
};

const SuccessTickContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
// The reason for not just using one SVG is, so we can animate the tick separately
const StyledTick = styled(TickIcon)`
  position: absolute;
`;
